module.exports = __webpack_public_path__ + "img/rank-2.896604c7.svg";